import React from 'react';
import TituloPlafonFalso from '../components/sections/TechoPlafonFalso/TituloPlafonFalso';
import IntroPlafonFalso from '../components/sections/TechoPlafonFalso/IntroPlafonFalso'; 
import DescripcionPlafonFalso from '../components/sections/TechoPlafonFalso/DescripcionPlafonFalso';
import FormularioContactoPlafon from '../components/sections/TechoPlafonFalso/FormularioContactoPlafon';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer'; 

const TechoPlafonFalsoPage = () => {
  return (
    <div>
      <Header />
        <TituloPlafonFalso />  
        <IntroPlafonFalso />  
        <DescripcionPlafonFalso />   
        <FormularioContactoPlafon />
      <Footer /> 
    </div>
  );
};

export default TechoPlafonFalsoPage;